export default __webpack_public_path__ + "static/media/trash-disabled.eeec9e5d.svg";